module.exports = __webpack_public_path__ + "d3efd324ed3bdd95708b658bb5ce86e5.svg";